<template>
    <div class="top-tags">
        <div class="tags-body">
            <p><a href="#" @click="this.$router.push('/')">首页</a> > <a href="#" @click="this.$router.push('/News/0')">新闻公告</a></p>
        </div>
    </div>
    <div class="zhu-body">
        
        <div class="body">
            <h3>新闻公告</h3>
            <el-tabs v-model="newActiveName" :tab-position="tabPosition" class="demo-tabs">
                <el-tab-pane label="最新公告">
                    <div class="news-div">
                        <ul>
                            <li v-for="item in announcementlist" :key="item" @click="goContent(item)">
                                <div class="icon-div"><el-icon class="icon-right"><ArrowRight/></el-icon></div>
                                <a href="#">{{item.title}}</a><span>{{item.dateTime}}</span>
                            </li>
                        </ul>
                    </div>
                    <div class="pagination">
                        <el-pagination
                            :page-size="20"
                            :pager-count="6"
                            layout="prev, pager, next"
                            :total="1000"
                        ></el-pagination>
                    </div>
                </el-tab-pane>
                <el-tab-pane v-model="newActiveName" label="新闻动态">
                    <div class="news-div">
                        <ul>
                            <li v-for="item in newlist" :key="item" @click="goContent(item)">
                                <div class="icon-div"><el-icon class="icon-right"><ArrowRight/></el-icon></div>
                                <a href="#">{{item.title}}</a><span>{{item.dateTime}}</span>
                            </li>
                        </ul>
                    </div>
                    <div class="pagination">
                        <el-pagination
                            :page-size="20"
                            :pager-count="6"
                            layout="prev, pager, next"
                            :total="1000"
                        >
                        </el-pagination>
                    </div>
                </el-tab-pane>
                <el-tab-pane v-model="newActiveName" label="" :disabled='true'>
                    <div class="news-content">
                        <div class="title">
                            <h2  v-text="showData.biaoti"></h2>
                            <p><span class="one">阅读量：{{showData.yueduliang}}</span>   <span v-text="showData.dateTime"></span></p>
                        </div>
                        <div class="content" v-html="showData.content">

                        </div>
                    </div>
                </el-tab-pane>
            </el-tabs>

        </div>
    </div>
    
</template>

<script>
import { ref } from '@vue/reactivity'
import { ArrowRight } from '@element-plus/icons'
export default {
    components: {
        ArrowRight
    },
    data() {
        return {
            //
            newActiveName: '0',
            tabPosition: ref('left'),
			showId: 0,
			showData:{
				dateTime: '',
				yueduliang: '',
				biaoti:''
			},
         announcementlist: [
                {
                		id: 7,
                		title: '开封泉源艺术品鉴定有限公司官方平台上线啦！！！',
                		dateTime: '2022年3月1号',
                		yueduliang: 889,
                		content:'<p>&nbsp; &nbsp;&nbsp;&nbsp;开封市政泉艺术品鉴定有限公司（简称政泉评级），是河南省开封市首批针对古钱币、银币进行鉴定评估的一家公司。<br>&nbsp; &nbsp;&nbsp;&nbsp;公司设立在八朝古都开封，钱币文化底蕴深厚，氛围好，玩家众多。公司业务包含对历代古钱币、机制银币、机制铜元、杂项鉴定评估，每一枚钱币至少两位评级师进行鉴定评估，确保钱币鉴定结果的准确性。公司宗旨就是坚持初心、优化服务。专注严谨、公平公正。让每一位泉友能够放心购买钱币，为每一位泉友的藏品保驾护航。</p>								<p>&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;--开封政泉艺术品鉴定有限公司</p>'
                	},
                	{
                		id: 8,
                		title: '河南郑州第三十一届全国红色收藏品交流会',
                		dateTime: '2022年3月8号',
                		yueduliang: 679,
                		content:'<p>经河南省民间文物艺术品商会红色收藏委员会会长办公会研究决定，定于2022年3月10日至12日在海馨静悦酒店、高城酒店、北斗星布丁酒店同时举行郑州第三十一届全国红色收藏品交流展示研讨会，届时诚邀全国各地藏友光临指导</p>'
                	},
                	{
                		id: 9,
                		title: '江苏章友会第二届精品徽章展销会暨徐州古玩城第二十一届全国古玩钱币交流会',
                		dateTime: '2022-01-01 12:00:01',
                		yueduliang: 888,
                		content:"<h5>徐州古玩城将于2022年3月12-13日在云龙区戏马台徐州古玩城举办第二届精品徽章展销会暨第二十一届全国古玩钱币交流会为期两天，特此邀请广大收藏爱好者前来参加此大型交流盛会！</h5>"
                	}
            ],
            newlist: [
                {
                		id: 1,
                		title: '开封政泉艺术品鉴定有限公司官方平台上线啦！！！',
                		dateTime: '2022年3月1号',
                		yueduliang: 889,
                		content:'<p>&nbsp; &nbsp;&nbsp;&nbsp;开封市政泉艺术品鉴定有限公司（简称政泉评级），是河南省开封市首批针对古钱币、银币进行鉴定评估的一家公司。<br>&nbsp; &nbsp;&nbsp;&nbsp;公司设立在八朝古都开封，钱币文化底蕴深厚，氛围好，玩家众多。公司业务包含对历代古钱币、机制银币、机制铜元、杂项鉴定评估，每一枚钱币至少两位评级师进行鉴定评估，确保钱币鉴定结果的准确性。公司宗旨就是坚持初心、优化服务。专注严谨、公平公正。让每一位泉友能够放心购买钱币，为每一位泉友的藏品保驾护航。</p>								<p>&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;--开封政泉艺术品鉴定有限公司</p>'
                	},
                	{
                		id: 2,
                		title: '河南郑州第三十一届全国红色收藏品交流会',
                		dateTime: '2022年3月8号',
                		yueduliang: 679,
                		content:'<p>经河南省民间文物艺术品商会红色收藏委员会会长办公会研究决定，定于2022年3月10日至12日在海馨静悦酒店、高城酒店、北斗星布丁酒店同时举行郑州第三十一届全国红色收藏品交流展示研讨会，届时诚邀全国各地藏友光临指导</p>'
                	},
                	{
                		id: 3,
                		title: '江苏章友会第二届精品徽章展销会暨徐州古玩城第二十一届全国古玩钱币交流会',
                		dateTime: '2022-01-01 12:00:01',
                		yueduliang: 888,
                		content:"<h5>徐州古玩城将于2022年3月12-13日在云龙区戏马台徐州古玩城举办第二届精品徽章展销会暨第二十一届全国古玩钱币交流会为期两天，特此邀请广大收藏爱好者前来参加此大型交流盛会！</h5>"
                	}
            ]
        }
    },
    mounted () {
        this.showId = this.$route.params.id
		if(this.showId == 0){
			this.newActiveName = '0'
			return
		}
		for(const ele of this.announcementlist){
			if(ele.id == this.showId){
				this.showData.dateTime = ele.dateTime
				this.showData.yueduliang = ele.yueduliang
				this.showData.biaoti = ele.title
				this.showData.content = ele.content
			}
		}
		for(const ele of this.newlist){
			if(ele.id == this.showId){
				this.showData.dateTime = ele.dateTime
				this.showData.yueduliang = ele.yueduliang
				this.showData.biaoti = ele.title
				this.showData.content = ele.content
			}
		}
		this.newActiveName = '2'
    },
    methods: {
        goContent (item) {
           this.newActiveName = '2'
		   this.showId = item.id
		   this.showData.dateTime = item.dateTime
		   this.showData.yueduliang = item.yueduliang
		   this.showData.biaoti = item.title
		   this.showData.content = item.content
        }
    },
    watch: {
        $route:function(toPath){
            //this.newActiveName = toPath.params.id
        }

	},
    
}
</script>

<style lang="scss" scoped>
//-------------------------------小跳转菜单
.top-tags {
    width: 100%;
    height: 40px;
    background: #f3f3f3;
    .tags-body {
        width: 1210px;
        margin: 0 auto;
        border: 1px solid #f3f3f3;
        text-align: left;
        position: relative;
        @media only screen and (max-width: 1210px) {
            width: 100%;
        }
        p {
            margin-top: 10px;
            padding-left: 5px;
            border-left: 6px solid #409EFF;
            
            a {
                color: #303133;
                font-size: 14px;
                text-decoration: none;
                &:hover {
                    color: #409EFF;
                }
            }
        }
    }
}


//标签页
.demo-tabs > .el-tabs__content {
  padding: 32px;
  background-color: #f4f5f7;
  color: #6b778c;
  font-size: 32px;
  font-weight: 600;
}

.el-tabs--right .el-tabs__content,
.el-tabs--left .el-tabs__content {
  height: 100%;
}

.zhu-body {
    width: 100%;
    
    .body {
        width: 1400px;
        margin: 0 auto;
        @media only screen and (max-width: 1400px) {
            width: 100%;
        }
        h3 {
            @media only screen and (max-width: 810px) {
                width: 90%;
                margin: 20px 5%;
            }
            font-size: 24px;
            text-align: left;
            margin: 20px 96px;
            padding: 10px 0;
            border-bottom: 1px solid #DFDFDF;
            position: relative;
            &::after {
                content: "";
                position: absolute;
                left: 48px;
                bottom: -1px;
                width: 100px;
                height: 2px;
                margin-left: -50px;
                background-color: #409EFF;
            }
        }
        .pagination {
            float:right
        }
        .news-div {
            text-align: left;
            //background: #F2F6FC;
            border-radius: 10px;
            padding: 10px;
            @media only screen and (max-width: 480px) {
                padding: 0;
                margin: 0;
            }
            ul {
                margin: 10px 0;
                padding: 0 10px;
                @media only screen and (max-width: 480px) {
                    padding: 0;
                    margin: 0;
                }
                li {
                    list-style: none;
                    font-size: 14px;
                    line-height: 40px;
                    border-bottom: 1px solid #DFDFDF;
                    cursor: pointer;
                    display: flex;
                    transition: .5s;
                    :before {
                        content: '';
                        position: absolute;
                        bottom: 0;
                        left: 0;
                        width: 100%;
                        height: 1px;
                        background: #e22434;
                        transform: scaleX(0);
                        transform-origin: 0%;
                        transition: .5s;
                    }
                    :hover:before {
                        transform: scaleX(1);
                    }

                    &:hover {
                        margin-left: 10px;
                        a, span{
                            color: #e22434;
                        }
                        .icon-right {
                            color: #e22434;
                        }
                    }
                    .icon-div {
                        padding-top: 2px; 
                        margin-right: 5px
                    }

                    a {
                        position: relative;
                        display: block;
                        color: #666666;
                        text-transform: uppercase;
                        text-decoration: none;
                        white-space: nowrap;
                        text-overflow:ellipsis;
                        overflow:hidden;
                        width: 80%;
                        @media only screen and (max-width: 650px) {
                            width: 60%;
                            font-size: 13px;
                        }
                        @media only screen and (max-width: 480px) {
                            width: 50%;
                        }
                    }
                    span {
                        width: 200px;
                        padding: 0;
                        color: #979595;
                        @media only screen and (max-width: 480px) {
                            font-size: 10px;
                            width: 120px;
                        }
                    }
                }
            }
        }
        .news-content {
            width: 1000px;
            @media only screen and (max-width: 1000px) {
                width: 100%;
            }
            .title {
                h2 {
                    font-size: 20px;
                    margin-right: 40px;
                }

                p {
                    font-size: 14px;
                    color: #999999;
                    margin-top: 14px;
                    line-height: 40px;
                    border-bottom: 1px solid #DFDFDF;
                    span {
                        @media only screen and (max-width: 560px) {
                            display: flex;
                        }
                        &:nth-child(1) {
                            margin-left:50px;
                            @media only screen and (max-width: 560px) {
                                margin-left:10px;
                            }
                        }
                        &:nth-child(2) {
                            margin-left:20px;
                            @media only screen and (max-width: 560px) {
                                margin-left:10px;
                            }
                        }
                    }
                    
                }
            }
            .content {
                margin-top: 20px;
                text-align: center;

                p {
                    margin: 0 auto;
                    font-size: 15px;
                    line-height: 25px;
                    text-align: center;
                    word-break: break-all;
                    word-wrap: break-word;
                    color: #606266;
                    padding: 15px;
                }
            }

        }
    }
}



</style>
